import { BulkUpdateProgressBanner } from "#src/batteries-included-components/Banners/BulkUpdateProgressBanner/BulkUpdateProgressBanner";
import { ESTIMATION_METHODS_QUERY_KEY } from "#src/components/hooks/adapters/useEstimationMethods";
import { FLOW_QUERY_KEY } from "#src/components/hooks/adapters/useFlows";
import { useStorageKey } from "#src/hooks/useStorageKey";
import { useQueryClient } from "@tanstack/react-query";
import { AssetStatus, Resources } from "@validereinc/domain";
import React from "react";
import { useParams } from "react-router";

export const FlowUpdateStatusBanner = () => {
  const { flowId } = useParams<{ flowId: string }>();
  const queryClient = useQueryClient();
  const [updateFlowStatusJobStorageKey] = useStorageKey(
    ["async-job"],
    `update-flow-status-${flowId}`
  );

  return (
    <BulkUpdateProgressBanner
      jobStorageKey={updateFlowStatusJobStorageKey}
      invalidate={() => {
        queryClient.refetchQueries({
          predicate: (query) =>
            [
              FLOW_QUERY_KEY,
              Resources.MEASUREMENT_SERIES,
              ESTIMATION_METHODS_QUERY_KEY,
            ].some((key) => query.queryKey.includes(key)),
          type: "all",
        });
      }}
      subject={{
        singular: "asset",
        plural: "assets",
      }}
      action={(job) =>
        job?.input.status === AssetStatus.INACTIVE ? "inactivate" : "activate"
      }
    />
  );
};
